import codes from './codes';

export const SurveyViews: any = {
    Accepted: {
        id: 1,
        surveyTypeId: 'Accepted',
        surveyGuidId: '00000029-1FDD-49C5-99C2-000000000001',
        surveyTypeGroupCode: codes.acceptSurveyGroupCode,
        title: 'Accepted',
    },
    Rejected: {
        id: 2,
        surveyTypeId: 'Rejected',
        surveyGuidId: '00000029-1FDD-49C5-99C2-000000000002',
        surveyTypeGroupCode: codes.rejectSurveyGroupCode,
        title: ' ',
    },
    Solicitor: {
        id: 3,
        surveyTypeId: 'Solicitor',
        surveyGuidId: '00000029-1FDD-49C5-99C2-000000000003',
        surveyTypeGroupCode: codes.solicitorSurveyGroupCode,
        title: 'Solicitor',
    },
    Confirmation: {
        id: 4,
        surveyTypeId: 'Confirmation',
    },
};

export const acceptedSurveyCode = 'Accepted';
export const confirmationSurveyCode = 'Confirmation';
export const rejectedSurveyCode = 'Rejected';
export const solicitorSurveyCode = 'Solicitor';
